module.exports = __webpack_public_path__ + "img/583629_2E1810_765648_3C1C14-256px.00dfc5f0.png";